// src/components/assistant/modeConfig.ts
// Mode configuration shared between components

import React from "react";
import { Zap, Wrench, Microscope, MessageSquare, Table2 } from "lucide-react";

export type AssistantMode = "quick" | "workspace" | "deep" | "sheets";

// Top-level panel tabs: Ask (quick/deep), Work (workspace), and Sheets
export type PanelTab = "ask" | "work" | "sheets";

export interface ModeConfig {
  icon: React.ReactNode;
  label: string;
  shortLabel: string;
  description: string;
  color: string;
}

export const modeConfig: Record<AssistantMode, ModeConfig> = {
  quick: {
    icon: React.createElement(Zap, { className: "h-3.5 w-3.5" }),
    label: "Quick",
    shortLabel: "Quick",
    description: "Fast answers, web search",
    color: "amber",
  },
  workspace: {
    icon: React.createElement(Wrench, { className: "h-3.5 w-3.5" }),
    label: "Workspace",
    shortLabel: "Work",
    description: "Build widgets, modify dashboard",
    color: "emerald",
  },
  deep: {
    icon: React.createElement(Microscope, { className: "h-3.5 w-3.5" }),
    label: "Deep Research",
    shortLabel: "Deep",
    description: "Multi-agent comprehensive reports",
    color: "violet",
  },
  sheets: {
    icon: React.createElement(Table2, { className: "h-3.5 w-3.5" }),
    label: "Sheets Copilot",
    shortLabel: "Sheets",
    description: "Create spreadsheets with AI",
    color: "cyan",
  },
};

// Panel tab configuration
export interface PanelTabConfig {
  icon: React.ReactNode;
  label: string;
  color: string;
}

export const panelTabConfig: Record<PanelTab, PanelTabConfig> = {
  ask: {
    icon: React.createElement(MessageSquare, { className: "h-3.5 w-3.5" }),
    label: "Ask",
    color: "violet",
  },
  work: {
    icon: React.createElement(Wrench, { className: "h-3.5 w-3.5" }),
    label: "Work",
    color: "emerald",
  },
  sheets: {
    icon: React.createElement(Table2, { className: "h-3.5 w-3.5" }),
    label: "Sheets",
    color: "cyan",
  },
};

// Map panel tab to default mode
export const tabToMode: Record<PanelTab, AssistantMode> = {
  ask: "quick",
  work: "workspace",
  sheets: "sheets",
};

// Map mode to panel tab
export const modeToTab = (mode: AssistantMode): PanelTab => {
  if (mode === "workspace") return "work";
  if (mode === "sheets") return "sheets";
  return "ask";
};
